import { fmtNumber } from "./shared";

export const OverviewSection = ({ general_information }) => {

  return (
    <>
      {/* Header */}
      <div className="w-full px-6 py-12">
        <div className="mx-auto text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Logistics Cost Analysis Results
          </h1>
          <p className="text-gray-600 text-lg mb-6">
            Analysis Period: {general_information?.date_range}
          </p>
          <div className="flex justify-center gap-4 flex-wrap">
            {general_information?.most_common_dispatch_zone && (
              <span className="rounded-full border border-gray-300 px-4 py-2 bg-gray-100 text-gray-700">
                Primary Zone:{" "}
                <span className="font-semibold text-gray-900">
                  {general_information?.most_common_dispatch_zone}
                </span>
              </span>
            )}
            <span className="rounded-full border border-gray-300 px-4 py-2 bg-gray-100 text-gray-700">
              Carriers Analyzed:{" "}
              <span className="font-semibold text-gray-900">
                {fmtNumber(general_information?.count_unique_list_carrier)}
              </span>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
